import { SPOTTER_STRINGS } from "../strings";

/**
 * Render decisions for `GamebookPickerTable`'s mini Gamebook rows (Point 7), extracted as pure
 * functions per this repo's convention (no React Testing Library — see `checkOrder.ts`).
 */

export type YardageTone = "pos" | "neg" | "zero";

export interface FormattedYardage {
  label: string;
  tone: YardageTone;
}

/**
 * `yardsGainedOrLost` is OMITTED (not `null`) on the wire when a play has nothing on record, and a
 * genuine 0-yard play arrives as the string `"0"` (customer-apps#136) — `undefined` here means
 * "nothing to show", never "unknown" or "zero". Sign/tone mirrors `GamebookScreen.tsx`'s own
 * `playCellContent` exactly, so a mini row and a full Gamebook row read the same way.
 */
export function formatYardage(
  yards: string | undefined
): FormattedYardage | null {
  if (yards === undefined) {
    return null;
  }
  const n = Number(yards);
  const tone: YardageTone = n > 0 ? "pos" : n < 0 ? "neg" : "zero";
  return { label: `${n > 0 ? "+" : ""}${yards}`, tone };
}

/** Same quarter copy `GamebookScreen.tsx`'s `situationCellContent` uses ("Q1".."Q4", "OT" at 5+). */
export function quarterLabel(quarter: number): string {
  return quarter >= 5
    ? SPOTTER_STRINGS.gamebook.toolbar.overtime
    : SPOTTER_STRINGS.gamebook.toolbar.quarter(quarter);
}
